export { default } from "./LogisticTaskStatus-component";
